import { render, staticRenderFns } from "./HelpCenterCardComponent.vue?vue&type=template&id=37d77f46&scoped=true"
import script from "./HelpCenterCardComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpCenterCardComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HelpCenterCardComponent.vue?vue&type=style&index=0&id=37d77f46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d77f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d77f46')) {
      api.createRecord('37d77f46', component.options)
    } else {
      api.reload('37d77f46', component.options)
    }
    module.hot.accept("./HelpCenterCardComponent.vue?vue&type=template&id=37d77f46&scoped=true", function () {
      api.rerender('37d77f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SupportServiceDialog/HelpCenterCardComponent.vue"
export default component.exports